import styles from "./LinearProgress.module.scss";

export const LinearProgress = () => (
  <div className={styles.progressbar} role="progressbar">
    <div className={styles.bar1} />
    <div className={styles.bar2} />
  </div>
);
